/* FILE: assets/acsy-product-sticky.js */

(function () {
  if (window.__acsyStickyInit) return;
  window.__acsyStickyInit = true;

  function findVariantJson(container) {
    const el = container.querySelector('[data-acsy-variant-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch(e) { return null; }
  }

  function onVariantChange(container) {
    const variants = findVariantJson(container);
    if (!variants || !Array.isArray(variants)) return;

    const form = container.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (!idInput) return;

    const getSelectedId = () => {
      if (idInput.tagName === 'SELECT') return Number(idInput.value);
      return Number(idInput.value);
    };

    const scrollToMediaId = (mediaId) => {
      if (!mediaId) return;
      const target = container.querySelector('[data-media-id="' + mediaId + '"]');
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const handle = () => {
      const vid = getSelectedId();
      const v = variants.find(x => Number(x.id) === Number(vid));
      if (!v) return;

      const fm = v.featured_media || v.featured_image || null;
      const mediaId = fm && (fm.id || fm.media_id) ? (fm.id || fm.media_id) : null;
      scrollToMediaId(mediaId);
    };

    form.addEventListener('change', (e) => {
      if (!e.target) return;
      if (e.target.name === 'id' || e.target.closest('[name="id"]') || e.target.closest('select') || e.target.closest('input')) {
        setTimeout(handle, 0);
      }
    });

    handle();
  }

  function init() {
    document.querySelectorAll('[data-acsy-product-page]').forEach(onVariantChange);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
